import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class InviteeType extends EntityDto implements IEntityDto {
    Invitee_Type_Id: string;
    InviteeTypeName: string;
    Description: string;
    Code: string;
    TotalCount: number;
    IsActive: boolean;

    constructor() {
        super();
        this.Invitee_Type_Id = "00000000-0000-0000-0000-000000000000";
        this.InviteeTypeName = "";
        this.Description = "";
        this.TotalCount = 0;
        this.Code = "";
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'InviteeTypeName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Designation Level Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },

        ];
    }
}
